import React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { AddHouseModal } from "@features/AddHouseModal/AddHouseModal";
import { Button } from "@components/Button";
import { useModalActions } from "@store/modal/modal";

interface IBillsEmptyStateProps {
  isFilterProblem?: boolean;
  variant?: "bill" | "overview";
}

export const JointBillEmptyHouseMessage: React.FC<IBillsEmptyStateProps> = ({
  isFilterProblem,
  variant = "bill",
}) => {
  const { t } = useTranslation();
  const { create } = useModalActions();

  const openAddHouseModal = () => {
    create((modalProps) => <AddHouseModal {...modalProps} />);
  };

  const title = t(
    isFilterProblem
      ? "jointBillEmptyHouseMessage.emptyHouseFilterResults.title"
      : "jointBillEmptyHouseMessage.emptyHouses.title",
  );
  const description = t(
    isFilterProblem
      ? "jointBillEmptyHouseMessage.emptyHouseFilterResults.description"
      : "jointBillEmptyHouseMessage.emptyHouses.description",
  );

  return (
    <div
      className={twMerge(
        "flex w-full flex-col items-center gap-8 px-6 py-10",
        variant === "overview" && "md:flex-row",
      )}
    >
      <img alt={title} src="/images/bills/empty-house-state.png" />
      <div
        className={twMerge(
          "flex flex-col items-center gap-6",
          variant === "overview" && "md:items-start",
        )}
      >
        <div
          className={twMerge(
            "flex flex-col items-center gap-3",
            variant === "overview" && "md:items-start",
          )}
        >
          <h2 className="text-2xl">{title}</h2>
          <p className="text-grey-dark">{description}</p>
        </div>
        {!isFilterProblem && (
          <Button onClick={openAddHouseModal}>
            {t("jointBillEmptyHouseMessage.emptyHouses.button")}
          </Button>
        )}
      </div>
    </div>
  );
};
